import { createFileRoute, redirect } from "@tanstack/react-router";
import { withQuery } from "@/lib/redirect-query";

// Legacy WordPress path — the post lives at the site root, not under /blog/.
export const Route = createFileRoute("/blog/10-ways-actually-make-hair-grow")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: withQuery("/10-ways-actually-make-hair-grow/", location.searchStr), statusCode: 301 });
  },
});
